import { render, staticRenderFns } from "./ComisionEquipo.vue?vue&type=template&id=566cdd0f&"
import script from "./ComisionEquipo.vue?vue&type=script&lang=js&"
export * from "./ComisionEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports